import { call, takeLatest } from "redux-saga/effects";
import * as categoryApis from "../apis/categoryApis"
import { CREATE_CATEGORY, DELETE_CATEGORY, EDIT_CATEGORY, LIST_CATEGORY, VIEW_CATEGORY } from "../actions/types";


export function* createCategoryWorker(action) {
    try {
        const res = yield call(categoryApis.createCategoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editCategoryWorker(action) {
    try {
        const res = yield call(categoryApis.editCategoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteCategoryWorker(action) {
    try {
        const res = yield call(categoryApis.deleteCategoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listCategoryWorker(action) {
    try {
        const res = yield call(categoryApis.listCategoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewCategoryWorker(action) {
    try {
        const res = yield call(categoryApis.viewCategoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher Func */
export function* createCategoryWatcher() {
    yield takeLatest(CREATE_CATEGORY, createCategoryWorker);
}
export function* editCategoryWatcher() {
    yield takeLatest(EDIT_CATEGORY, editCategoryWorker);
}
export function* deleteCategoryWatcher() {
    yield takeLatest(DELETE_CATEGORY, deleteCategoryWorker);
}
export function* listCategoryWatcher() {
    yield takeLatest(LIST_CATEGORY, listCategoryWorker);
}
export function* viewCategoryWatcher() {
    yield takeLatest(VIEW_CATEGORY, viewCategoryWorker);
}